import { defineComponent, getCurrentInstance, onBeforeUnmount, onMounted, reactive, ref, watch } from '@vue/composition-api'
import _ from 'lodash'
import { useRequest, useSelector, useAsyncDispatch, useDispatch } from '@/utils/bhooks';
import './index.scss';
import {
  getAnnLog,
} from '@/services/setting/announcementManagement'
import { textRange } from '@/utils/assist'
import i18n from '@/locales';
const AnnouncementMarguee = defineComponent({
  setup(props, context) {
    const { app } = useSelector(({ app }) => ({ app }));
    const commit = useDispatch()
    const dispatch = useAsyncDispatch()
    const { state: getAnnLogState, run: getAnnLogRun } = useRequest(getAnnLog)
    const instance = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    let needScroll = ref(false)
    let needDisabled = ref(false)
    const handleCancel = () => {
      commit('app/commonMutations', { announcementqeeVisible: false })
      const reg = /（(.+?)）/
      const user = reg.exec(window?.sessionStorage.getItem('user') || '')
      if(app.announcementOnlyShow){
        getAnnLogRun({ id: app.announcementData.id,userName:user?.[1] })
      }
    }

    const filterHtmlTag = (label: string): string => {
      let vnode = document.createElement("div")
      vnode.innerHTML += label
      return vnode.innerText
    }

    watch(()=>app.announcementqeeVisible,(val)=>{
      if(val){
        instance?.proxy.$nextTick(()=>{
          needScroll.value = textRange(document.getElementById('marquee'))
        })
      }
    },{immediate:true})

    // onMounted(() => {
    //   setTimeout(() => {
    //     const marquee = document.getElementById('marquee')
    //     console.log(marquee)
    //     marquee?.addEventListener('mousemove', () => {
    //       marquee?.stop()
    //     })
    //     marquee?.addEventListener('mouseout', () => {
    //       marquee?.start()
    //     })
    //   },100)

    // })
    // onBeforeUnmount(() => {
    //   const marquee = document.getElementById('marquee')
    //   marquee?.removeEventListener('mousemove', () => {
    //     marquee?.stop()
    //   })
    //   marquee?.removeEventListener('mouseout', () => {
    //     marquee?.start()
    //   })
    // })
    return () => {
      return (
        <div>
          {app.announcementqeeVisible &&
            <div class="announcement_marguee">
              <el-tooltip
                content={i18n.locale === 'en' ? filterHtmlTag(app.announcementData?.titleEn) : filterHtmlTag(app.announcementData?.title)}
                placement="bottom-start"
                disabled={needDisabled.value}
              >
              <div
                ref = 'margueeTitle'
                onMouseenter={(event) => {
                  needDisabled.value = context.refs?.['margueeTitle']?.scrollWidth <= Math.round(context.refs?.['margueeTitle']?.getBoundingClientRect().width)
                }}
                onMouseleave={(event) => needDisabled.value = context.refs?.['margueeTitle']?.scrollWidth <= Math.round(context.refs?.['margueeTitle']?.getBoundingClientRect().width)}
                class="announcement_marguee_title"
              >{i18n.locale === 'en' ? filterHtmlTag(app.announcementData?.titleEn) : filterHtmlTag(app.announcementData?.title)}</div>
            </el-tooltip>
              <span>:</span>
              <marquee
                id='marquee'
                scrollamount={ needScroll.value ? 8 : 0 }
                style={{ flex: 1 }}
                direction='left'
                hspace={10}
              ><div>{i18n.locale === 'en' ? filterHtmlTag(app.announcementData?.contentEn) : filterHtmlTag(app.announcementData?.content)}</div></marquee>
              <span class='close_but' onClick={handleCancel}><i class='el-icon-close' /></span>
            </div>
          }
        </div>
      )
    }

  }
})
export default AnnouncementMarguee
